module.exports = __webpack_public_path__ + "img/society-farffler-avatar.e4beca04.png";